module.exports = __webpack_public_path__ + "img/img131.eb055fdd.png";